var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLockFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.86 9.407c0-.773-.54-1.417-1.288-1.598-.412-.103-.85-.051-1.263-.051-.18 0-.258-.052-.258-.258V6.443a5.575 5.575 0 00-.67-2.86c-1.108-1.985-3.247-2.913-5.36-2.5-2.423.463-4.073 2.551-4.098 5.025v1.418c0 .18-.052.232-.232.232h-.748c-1.134 0-1.83.696-1.83 1.83v7.603c0 1.134.696 1.83 1.83 1.83H14.16c.928 0 1.7-.748 1.7-1.65.027-2.68 0-5.335 0-7.964zM4.625 7.45c.051-.748-.078-1.521.128-2.269.413-1.572 1.805-2.577 3.48-2.5 1.495.052 2.835 1.263 3.093 2.784.129.696.025 1.392.051 2.088 0 .206-.129.18-.258.18H4.933c-.232.026-.335-.026-.31-.283zm9.226 9.87H2.124c-.258 0-.335-.077-.335-.334V9.768c0-.258.051-.335.335-.335h11.752c.258 0 .31.077.31.31v7.242c0 .283-.104.335-.336.335z",
    fill: "currentColor"
  })));
}

export default SvgLockFile;